export default {
  init() {
    // JavaScript to be fired on the rewards page
    // select account
    $('#account-select #account').change(function() {
      mhpa.loadAccountData();

      // load user data by reloading the page
      location.reload();
    });	
    
    // make global, since webpack uses enclosures to scope partials
    window.mhpa = window.mhpa || {};
    window.mhpa.loadAccountData = function() {
      
    }

    mhpa.loadAccountData();
  },
  finalize() {
    // JavaScript to be fired on the rewards page, after the init JS
  },
};
